// @flow
// only supports valid RFC2822 or ISO date format
import moment from "moment";

export default (d: string | Date) => moment(d).isValid();
